import { makeStyles } from 'tss-react/mui';

const useStylesFieldPhoneBlock: MaterialUIStylesCallback = makeStyles()((theme: MainTheme): MaterialUIStyles => ({
  fieldPhoneBlock: {
    '& > div': {
      '&:first-of-type': {
        width: 'calc(90% - 5px)',
        marginRight: 5,
        [theme.breakpoints.down('md')]: {
          width: 'calc(80% - 5px)',
        },
      },
      '&:last-of-type': {
        width: '10%',
        [theme.breakpoints.down('md')]: {
          width: '20%',
        },
      },
    },
  },
}));

export default useStylesFieldPhoneBlock;
